import L from 'leaflet';

export const InteractiveTooltip = L.Tooltip.extend({
    onAdd(...args) {
        const returnValue = L.Tooltip.prototype.onAdd.apply(this, args);

        const me = this;
        const el = me.getElement();

        if (!this.clickListener) {
            this.clickListener = (event) => this.fireEvent('click', { event });
            this.mouseEnterListener = (event) => this.fireEvent('mouseenter', { event });
            this.mouseExitListener = (event) => this.fireEvent('mouseleave', { event });

            el.addEventListener('click', this.clickListener);
            el.addEventListener('mouseenter', this.mouseEnterListener);
            el.addEventListener('mouseleave', this.mouseExitListener);
        }

        // don't lose pointer events on tooltips
        el.style.pointerEvents = 'auto';

        return returnValue;
    },

    onRemove(...args) {
        const el = this.getElement();
        el.removeEventListener('click', this.clickListener);
        el.removeEventListener('mouseenter', this.mouseEnterListener);
        el.removeEventListener('mouseleave', this.mouseExitListener);

        this.clickListener = null;
        this.mouseEnterListener = null;
        this.mouseExitListener = null;

        return L.Tooltip.prototype.onRemove.apply(this, args);
    },
});
